import { VAlert } from 'vuetify/lib/components/VAlert';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTreeview } from 'vuetify/lib/components/VTreeview';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.deleteConfirmation'),
      "open": _vm.showDeleteDialog,
      "color": "red",
      "buttons": [{
        text: _vm.$i18n_t('Common.cancel'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('Common.delete'),
        color: 'red',
        emit: 'delete',
        disabled: _vm.linkedStateAggregations.length > 0
      }]
    },
    on: {
      "close": _vm.closeDeleteDialog,
      "delete": _vm.handleConfirmDelete
    }
  }, [_vm.linkedStateAggregations && _vm.linkedStateAggregations.length ? [_vm._v("\n      " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.deleteAggregateText')) + "\n      "), _c(VTreeview, {
    staticClass: "mt-2 infoTree",
    attrs: {
      "items": _vm.linkedStateAggregations,
      "item-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function ({
        item
      }) {
        return [item.icon ? _c(VIcon, {
          staticStyle: {
            "width": "25px"
          },
          attrs: {
            "size": "16"
          },
          domProps: {
            "textContent": _vm._s(`fal fa-${item.icon}`)
          }
        }) : _vm._e()];
      }
    }, {
      key: "label",
      fn: function ({
        item
      }) {
        return [[_vm._v("\n            " + _vm._s(item.title) + "\n          ")], _vm._v("\n           \n          "), item.id ? _c('span', {
          staticStyle: {
            "font-size": "10px"
          }
        }, [_vm._v("(" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(item.id) + ")")]) : _vm._e()];
      }
    }], null, false, 1649902215)
  })] : _vm._e()], 2), _c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, [_c('core-n20Card', {
    staticClass: "dt-card-text-01"
  }, [_c(VRow, [_c(VCol, {
    staticStyle: {
      "padding-top": "0px"
    },
    attrs: {
      "cols": "12"
    }
  }, [_vm.deviceDriver ? [_c('router-link', {
    attrs: {
      "to": `/virtual-device-drivers/${_vm.deviceDriver.id}?tab=meta-information`
    }
  }, [_c('h4', {
    attrs: {
      "data-cy": "device-driver-label"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.deviceDriver')) + ":\n                  " + _vm._s(_vm.deviceDriver.title) + "\n                ")]), _c('div', {
    staticStyle: {
      "display": "flex",
      "overflow": "hidden",
      "height": "125px"
    }
  }, [_c('div', {
    staticClass: "image-upload-wrapper",
    staticStyle: {
      "margin-left": "0px",
      "margin-right": "16px"
    }
  }, [_c('img', {
    staticClass: "image-upload-img",
    attrs: {
      "src": _vm.deviceDriver.image ? _vm.getImageUrl(_vm.deviceDriver.image) : 'img/niota-classic/placeholder.png'
    }
  })]), _vm._v("\n                  " + _vm._s(_vm.deviceDriver.description) + "\n                ")])])] : _vm._e()], 2)], 1), _c('h5', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.availableTargetVariables')))]), _c(VDataTable, {
    ref: "statesTable",
    class: `mt-2 mb-2 ${_vm.themeMode}`,
    attrs: {
      "headers": _vm.tableLocalizations.headers,
      "items": _vm.tableItems,
      "item-key": "id",
      "hide-default-footer": "",
      "items-per-page": -1
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (props) {
        return [props.item.properties ? _c('tr', {
          key: `state-row-${props.item.properties.key}`
        }, [_c('td', {
          staticClass: "text-left state-value-item",
          staticStyle: {
            "width": "80%"
          }
        }, [_vm._v("\n                " + _vm._s(props.item.properties.title) + "\n              ")]), _c('td', {
          staticClass: "text-left",
          staticStyle: {
            "width": "5%"
          }
        }, [_c('div', {
          staticClass: "text-truncate",
          attrs: {
            "title": props.item.properties.valueType || '-'
          }
        }, [_vm._v("\n                  " + _vm._s(props.item.properties.valueType) + "\n                ")])]), _c('td', {
          staticClass: "text-left",
          staticStyle: {
            "width": "5%"
          }
        }, [_vm._v(_vm._s(props.item.properties.unit || '-'))]), _c('td', {
          staticClass: "text-center"
        }, [!_vm.partOfDataStates(props.item) ? _c(VIcon, {
          attrs: {
            "color": _vm.color,
            "medium": "",
            "data-cy": "add_state_definition",
            "disabled": _vm.isProductiveVersion || _vm.readonly
          },
          on: {
            "click": function ($event) {
              return _vm.addState(props.item);
            }
          }
        }, [_vm._v("\n                  fal fa-plus-circle\n                ")]) : _c(VIcon, {
          attrs: {
            "color": _vm.color,
            "medium": "",
            "disabled": _vm.isProductiveVersion || _vm.readonly
          }
        }, [_vm._v("\n                  fal fa-check-circle\n                ")])], 1)]) : _vm._e()];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n            ")])];
      },
      proxy: true
    }])
  })], 1)], 1)], 1), _c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, [_c('core-n20Card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "buttons": _vm.actionButtons
    },
    on: {
      "addItem": _vm.addItem
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.dataStates')))]), _c(VDataTable, {
    class: `mt-2 mb-2 states-table ${_vm.themeMode}`,
    attrs: {
      "headers": _vm.dataStatesHeaders,
      "items": _vm.template.stateDefinition,
      "item-key": "key",
      "hide-default-footer": "",
      "disable-pagination": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (props) {
        return [props.item.properties ? _c('tr', {
          key: `state-row-${props.item.key}`,
          attrs: {
            "disabled": _vm.isProductiveVersion || _vm.readonly
          }
        }, [!_vm.isProductiveVersion && !_vm.readonly ? _c('td', {
          class: 'text-center handle'
        }, [_c(VIcon, {
          staticStyle: {
            "opacity": "1"
          },
          attrs: {
            "small": ""
          }
        }, [_vm._v("fal fa-arrows")])], 1) : _vm._e(), _c('td', {
          staticClass: "text-center"
        }, [_c(VIcon, {
          attrs: {
            "small": ""
          }
        }, [_vm._v("fal fa-" + _vm._s(props.item.properties.faIcon))])], 1), _c('td', {
          staticClass: "text-left state-value-item",
          staticStyle: {
            "width": "50%"
          }
        }, [_vm._v("\n                " + _vm._s(props.item.properties.title) + "\n              ")]), _c('td', {
          staticClass: "text-left",
          staticStyle: {
            "width": "5%"
          }
        }, [_c('div', {
          staticClass: "text-truncate",
          attrs: {
            "title": props.item.properties.valueType || '-'
          }
        }, [_vm._v("\n                  " + _vm._s(props.item.properties.valueType) + "\n                ")])]), _c('td', {
          staticClass: "text-left",
          staticStyle: {
            "width": "5%"
          }
        }, [_vm._v(_vm._s(props.item.properties.unit || '-'))]), _c('td', {
          staticClass: "text-center",
          staticStyle: {
            "width": "15%"
          }
        }, [_c(VChip, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t(`DigitalTwin.DigitalTwin.states.dataSources.${props.item.properties.binding.type}`)) + "\n                ")])], 1), _c('td', {
          staticClass: "text-center"
        }, [props.item.properties.title !== '_parsed' && props.item.properties.title !== '_raw' && !_vm.readonly ? _c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.edit'),
            "small": "",
            "disabled": _vm.isProductiveVersion
          },
          on: {
            "click": function ($event) {
              return _vm.editState(props.item);
            }
          }
        }, [_vm._v("\n                  fal fa-edit\n                ")]) : _vm._e(), [_vm._v("\n                   \n                  "), _vm.isStateDeletable(props.item) ? _c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.delete'),
            "small": "",
            "disabled": _vm.isProductiveVersion
          },
          on: {
            "click": function ($event) {
              return _vm.deleteState(props.item.key);
            }
          }
        }, [_vm._v("\n                    fal fa-trash-alt\n                  ")]) : _vm._e()]], 2)]) : _vm._e()];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n            ")])];
      },
      proxy: true
    }])
  })], 1)], 1)], 1), _c(VDialog, {
    attrs: {
      "max-width": "1000px",
      "persistent": ""
    },
    model: {
      value: _vm.stateEditDialog,
      callback: function ($$v) {
        _vm.stateEditDialog = $$v;
      },
      expression: "stateEditDialog"
    }
  }, [_vm.stateEditDialog ? _c('core-dtwin-state-edit', {
    tag: "component",
    attrs: {
      "tenantId": _vm.template.tenantId,
      "mode": _vm.stateEditItem == null ? 'create' : 'edit',
      "dataSources": _vm.dataSources.filter(s => s.type !== 'iothub' && s.type !== 'iothub-aggregate' && s.type !== 'virtual-device' && s.type !== 'aggregate' && s.type !== 'dynamical-data-routing'),
      "otherStates": _vm.addedStatesItems,
      "bridgeConfigs": _vm.bridgeConfigs,
      "templateContext": true,
      "templateTitle": _vm.template.title,
      "linkedTwinCount": _vm.templateInformation.linkedDevicesTotalCount,
      "stateDefinition": _vm.template.stateDefinition,
      "keyIsEditable": _vm.templateInformation.linkedDevicesTotalCount < 1 || _vm.stateEditItem && _vm.templateInformation.unsyncedChanges.some(changes => changes.modification === `Added data state ${_vm.stateEditItem.key}`)
    },
    on: {
      "close": _vm.closeEditWithError,
      "save": _vm.saveState
    },
    model: {
      value: _vm.stateEditItem,
      callback: function ($$v) {
        _vm.stateEditItem = $$v;
      },
      expression: "stateEditItem"
    }
  }) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };